import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOutputMaterialList } from '../api/fetch-output-materials.api';
import type { FetchMaterialsParams } from '../utils/match-maker.types';
import type { ApiError } from '@/utils/types';

export const getOutputMaterialList = createAsyncThunk(
  'MatchMaker/getOutputMaterialList',
  async (params: FetchMaterialsParams | undefined, thunkAPI) => {
    try {
      // Call API to get output material list
      return await fetchOutputMaterialList(params || {});
    } catch (e: unknown) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to fetch output material list'
      );
    }
  }
);
